import Dexie from 'dexie';

// Define the types for our data
export interface Play {
  id?: number;
  gameId: number;
  timestamp: number;
  down: number;
  distance: number;
  yardLine: number;
  playType: string;
  result: string;
  yardsGained: number;
  scoringPlay: boolean;
  notes?: string;
  synced: boolean;
}

export interface Game {
  id?: number;
  date: string;
  homeTeam: string;
  awayTeam: string;
  location: string;
  synced: boolean;
}

// Create a Dexie database class
class FootballDatabase extends Dexie {
  games: Dexie.Table<Game, number>;
  plays: Dexie.Table<Play, number>;

  constructor() {
    super('FootballGameLogger');
    
    // Define tables and their primary keys and indexes
    this.version(1).stores({
      games: '++id, date, homeTeam, awayTeam, synced',
      plays: '++id, gameId, timestamp, playType, synced'
    });
    
    // Define typed tables
    this.games = this.table('games');
    this.plays = this.table('plays');
  }
}

// Create and export a database instance
export const db = new FootballDatabase();

// Export a function to initialize the database
export async function initDatabase() {
  try {
    await db.open();
    console.log('Database initialized successfully');
    return true;
  } catch (error) {
    console.error('Failed to initialize database:', error);
    return false;
  }
}